<template v-slot:default="{ isActive }">
    <v-dialog
      v-model="dialog"
      width="150rem"
      class="layer-popup"
      scrollable
    >
      <v-card>
        <!--content-->
        <v-card-title class="d-flex justify-space-between align-center">
          <div class="pop-title">{{t('message.validateData')}}
            <div class="sub-txt">
              {{t('message.excludeFromReport')}}
            </div>
          </div>
          <v-btn
            icon="mdi-close"
            variant="text"
            @click.stop="onClickClose"
          ></v-btn>
        </v-card-title>
        <!--content-->
        <div class="pop-cont05">
          <div class="tab-group ty01 ty01-01">
            <v-tabs
              v-model="tab"
            >
              <v-tab value="tabCont1">{{t('message.monitoring')}}</v-tab>
              <v-tab value="tabCont2">{{t('message.safetyTalk')}}</v-tab>
              <v-tab value="tabCont3">{{t('message.changeHistory')}}</v-tab>
            </v-tabs>
          </div>
        </div>
        <v-card-text>
          <v-tabs-window v-model="tab">
            <v-tabs-window-item value="tabCont1">
              <MtDialog03Cont1 :is-active="tab === 'tabCont1'"/>
            </v-tabs-window-item>
            <v-tabs-window-item value="tabCont2">
              <MtDialog03Cont2 :is-active="tab === 'tabCont2'"/>
            </v-tabs-window-item>
            <v-tabs-window-item value="tabCont3">
              <MtDialog03Cont3 :is-active="tab === 'tabCont3'"/>
            </v-tabs-window-item>
          </v-tabs-window>
        </v-card-text>
        <!--버튼-->
        <v-card-actions class=" d-flex justify-end pop-bottom-bg" v-if="false">
          <c-btn01 :btnText="t('message.confirm')" @click="onClickConfirm"/>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script setup lang="ts">
import {ref} from 'vue';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

const emit = defineEmits(['close', 'confirm'])
const dialog = defineModel()

//bind
const tab = ref('tabCont1')

const onClickClose=()=>{
  emit('close')
  dialog.value = false
}

const onClickConfirm=()=>{
  emit('confirm')
  dialog.value = false
}
</script>


<style lang="scss">
</style>
